import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { BreadcrumbsBlockInterface } from '~/types/AppData/PageBuilder/BreadcrumbsBlockInterface';
import BreadcrumbsSeparator from '~/icons/breadcrumbsSeparator';

export default component$<BreadcrumbsBlockInterface['props']>(
  ({ breadcrumbs = [] }): JSX.Element => {
    return (
      <nav aria-label='Breadcrumb' class='font-group-tiny flex items-center'>
        <ol class='flex items-center gap-2'>
          {breadcrumbs.map((breadcrumb, index) => {
            const isLast = index === breadcrumbs.length - 1;

            return (
              <li key={index} class='flex items-center gap-2'>
                {breadcrumb.url && !isLast ? (
                  <a class='text-primary' href={breadcrumb.url}>
                    {breadcrumb.name}
                  </a>
                ) : (
                  <span class='text-grey'>{breadcrumb.name}</span>
                )}

                {!isLast && <BreadcrumbsSeparator />}
              </li>
            );
          })}
        </ol>
      </nav>
    );
  }
);
